const FOOD_API_URL = '/api/usda/foods/search';

// Nutrients to extract, in display order. Only those present in the API
// response are included — missing nutrients are simply omitted.
const NUTRIENT_NAMES = [
  'Energy',
  'Protein',
  'Total lipid (fat)',
  'Carbohydrate, by difference',
  'Fiber, total dietary',
  'Sugars, total including NLEA',
];

// Returns { description, brand, nutrients, servingSize } or null.
// nutrients is an array of { display } — only for nutrients found.
export async function fetchFoodInfo(searchTerm) {
  try {
    const response = await fetch(FOOD_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: searchTerm,
        dataType: ['Foundation', 'SR Legacy', 'Branded'],
        pageSize: 1,
        requireAllWords: true,
      }),
    });
    if (!response.ok) throw new Error(`USDA API returned ${response.status}`);
    const { foods } = await response.json();
    if (!foods?.length) return null;

    const { description, brandName, brandOwner, foodNutrients, servingSize, servingSizeUnit } = foods[0];
    const nutrientMap = {};
    for (const n of foodNutrients ?? []) {
      nutrientMap[n.nutrientName] = `${n.value} ${n.unitName.toLowerCase()}`;
    }

    const nutrients = [];
    for (const name of NUTRIENT_NAMES) {
      if (nutrientMap[name]) {
        nutrients.push({ display: nutrientMap[name] });
      }
    }

    return {
      description: description || null,
      brand: brandName || brandOwner || null,
      nutrients,
      servingSize: servingSize ? `${servingSize} ${servingSizeUnit}` : '100 g',
    };
  } catch (error) {
    console.error('Could not fetch food info:', error);
    return null;
  }
}
